import Vue from 'vue'
import OtpInput from '@bachdgvn/vue-otp-input'

Vue.component('v-otp-input', OtpInput)
